import { createSlice } from "@reduxjs/toolkit"
import { fetchTodos, userLogin } from "./loginActions"

// A bad write anywhere (e.g. JSON.stringify(undefined) landing in
// localStorage as the literal string "undefined") used to crash the whole
// app at module-load time — JSON.parse("undefined") throws, and this file
// runs before React even mounts, so there was no way to recover short of
// manually clearing localStorage. Falls back to null (same as a missing
// key) and clears the bad entry so it self-heals on next load.
const safeJSONParse = key => {
    const raw = localStorage.getItem(key)
    if (raw === null) return null
    try {
        return JSON.parse(raw)
    } catch (e) {
        localStorage.removeItem(key)
        return null
    }
}

let user_LS
let resources_LS
let user_profile
if (typeof localStorage !== `undefined`) {
    user_LS = safeJSONParse("user")
    resources_LS = safeJSONParse("resources")
    user_profile = safeJSONParse("userProfile")
}

let selected_user_LS
if (typeof localStorage !== `undefined`) {
    selected_user_LS = safeJSONParse("selectedUser")
}

let user_auth_LS
if (typeof localStorage !== `undefined`) {
    user_auth_LS = safeJSONParse("userAuth")
}

let user_location_LS
if (typeof localStorage !== `undefined`) {
    user_location_LS = safeJSONParse("userLocation")
}

var login_tracker_LS
if (typeof localStorage !== `undefined`) {
    login_tracker_LS = safeJSONParse("loginTracker")
}

let alertState = {
    open: false,
    vertical: "top",
    horizontal: "center",
    duration: 6000,
    type: "success",
    variant: "filled",
    message: "",
}

const initialState = {
    loading: false,
    loggedin: false,
    user: user_LS || {},
    error: "",
    auth: user_auth_LS || {},
    tokenRefreshed: false,
    resources: resources_LS || [],
    userLocation: user_location_LS || {},
    data: [],
    languages: [],
    timeZones: [],
    userProfile: user_profile || {},
    selectedUser: selected_user_LS || {},
    schedule: {},
    blockoutDays: [],
    associatedClinics: [],
    alert: alertState,
    loginTracker: login_tracker_LS || {},
    refetchingToken: false,
    receivedNotification: false,
    updatingToken: false,
    settimeoutObject: null,
    showUserSelectModal: false,
}

const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        loginRequest: (state, action) => {
            state.loading = true
        },
        loginSuccess: (state, action) => {
            console.log(action.payload, "lkfjsdljflsfj")
            // profileForUser[0] being missing (empty/absent profileForUser)
            // used to write the bare word `undefined` into localStorage via
            // JSON.stringify(undefined) — see safeJSONParse above for what
            // that did on the next page load. Falls back to {} instead.
            const profile = action.payload.profileForUser?.[0] || {}
            localStorage.setItem("user", JSON.stringify(action.payload))
            localStorage.setItem("userProfile", JSON.stringify(profile))
            state.loading = false
            state.loggedin = true
            state.user = action.payload
            state.userProfile = profile
        },
        loginFailure: (state, action) => {
            state.loading = false
            state.user = {}
            state.error = action.payload
        },
        logoutAction: (state, action) => {
            localStorage.setItem("user", JSON.stringify({}))
            localStorage.setItem("resources", JSON.stringify([]))
            localStorage.setItem("userAuth", JSON.stringify([]))
            localStorage.setItem("userLocation", JSON.stringify([]))
            localStorage.setItem("userProfile", JSON.stringify({}))
            localStorage.setItem("patientDetails", JSON.stringify({}))
            localStorage.removeItem("organization")
            localStorage.removeItem("clinic")
            localStorage.removeItem("clinicsList")
            localStorage.removeItem("organizationsList")
            localStorage.removeItem("selectedUser")
            state.selectedUser = {}
            state.user = {}
            state.loading = false
            state.loggedin = false
            state.error = ""
        },
        updateAuth: (state, action) => {
            localStorage.setItem("userAuth", JSON.stringify(action.payload))
            state.auth = action.payload
        },
        updateTokenRefreshed: (state, action) => {
            state.tokenRefreshed = action.payload
        },
        updateResources: (state, action) => {
            state.resources = action.payload
        },
        updateUserLocation: (state, action) => {
            state.userLocation = action.payload
        },
        updateLanguages: (state, action) => {
            state.languages = action.payload
        },
        updateTimeZones: (state, action) => {
            state.timeZones = action.payload
        },
        updateUserProfile: (state, action) => {
            state.userProfile = action.payload
        },
        updateSchedule: (state, action) => {
            state.schedule = action.payload
        },
        updateBlockoutDays: (state, action) => {
            state.blockoutDays = action.payload
        },
        associatedClinicsUsers: (state, action) => {
            state.associatedClinics = action.payload
        },
        updateAlert: (state, action) => {
            state.alert = action.payload
        },
        updateLoading: (state, action) => {
            state.loading = action.payload
        },
        updateLoginTracker: (state, action) => {
            localStorage.setItem("loginTracker", JSON.stringify(action.payload))
            state.loginTracker = action.payload || {}
        },
        refetchingToken: (state, action) => {
            state.refetchingToken = action.payload
        },
        updateReceivedNotification: (state, action) => {
            state.receivedNotification = action.payload
        },
        updateCoachMarks: (state, action) => {
            state.loginTracker.userProfile = state.loginTracker.userProfile
                ? { ...state.loginTracker.userProfile, coachMark: true }
                : { coachMark: true }
        },
        updateUpdatingToken: (state, action) => {
            state.updatingToken = action.payload
        },
        updateSettimeoutObject: (state, action) => {
            state.settimeoutObject = action.payload
        },
        updateLoggedIn: (state, action) => {
            state.loggedin = action.payload
        },
        setShowUserSelectModal: (state, action) => {
            state.showUserSelectModal = action.payload
        },
        updateSelectedUser: (state, action) => {
            localStorage.setItem("selectedUser", JSON.stringify(action.payload))
            state.selectedUser = action.payload
        },
    },
})

export const {
    loginRequest,
    loginSuccess,
    loginFailure,
    logoutAction,
    updateAuth,
    updateTokenRefreshed,
    updateResources,
    updateUserLocation,
    updateLanguages,
    updateTimeZones,
    updateUserProfile,
    updateSchedule,
    updateBlockoutDays,
    associatedClinicsUsers,
    updateAlert,
    updateLoading,
    updateLoginTracker,
    refetchingToken,
    updateReceivedNotification,
    updateCoachMarks,
    updateUpdatingToken,
    updateSettimeoutObject,
    updateLoggedIn,
    setShowUserSelectModal,
    updateSelectedUser,
} = loginSlice.actions

export default loginSlice.reducer
